import Model from './model';

import { parseYYYYMMDD } from '../utils/date';

export default Model.extend( {

    initialize(attrs) {
        Model.prototype.initialize.call( this, attrs );

        if ('string' === typeof attrs.date)
            this.set( 'date', parseYYYYMMDD( attrs.date ), { silent: true } );
        else if ('number' === typeof attrs.date)
            this.set( 'date', new Date( attrs.date * 1000 ), { silent: true } );
    },

    customParser(payload) {
        payload.done = true;

        if ('string' === typeof payload.date)
            payload.date = parseYYYYMMDD( payload.date );
        else if ('number' === typeof payload.date)
            payload.date = new Date( payload.date * 1000 );

        return payload;
    }

} );


// WEBPACK FOOTER //
// ./src/js/model/comment.js